import { Link, Navigate, useParams } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';
import { AUTHORS, AUTHORS_BY_SLUG, LEARN_POSTS, LEGACY_AUTHOR_SLUGS } from '../../data/seoRetrofitData';

export default function AuthorProfilePage() {
  const { slug } = useParams();
  if (LEGACY_AUTHOR_SLUGS.includes(slug)) return <Navigate to={`/authors/${AUTHORS[0].slug}`} replace />;
  const author = AUTHORS_BY_SLUG[slug];
  if (!author) return <Navigate to="/learn" replace />;

  const authoredPosts = LEARN_POSTS.filter((post) => post.authorSlug === slug && !post.noindex);

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="author-profile-page">
      <SEOHead
        title={`${author.name} | Author | Flash Funding`}
        description={`${author.name} is the Founder and Managing Director of Flash Funding, writing practical guides on asset finance and business lending in Australia.`}
        canonical={`/authors/${slug}`}
        schema={[{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: author.name,
          jobTitle: 'Founder and Managing Director',
          image: `https://www.flashfunding.loan${author.photo}`,
          worksFor: { '@type': 'Organization', name: 'Flash Funding', url: 'https://www.flashfunding.loan' },
          url: `https://www.flashfunding.loan/authors/${slug}`,
        }]}
      />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="author-profile-main-section">
        {author.photo && (
          <img src={author.photo} alt={author.name} className="w-32 h-32 rounded-full object-cover mb-5" data-testid="author-profile-photo" />
        )}
        <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-3">{author.name}</h1>
        <p className="text-white/70 text-sm mb-2">{author.credentials}</p>
        <p className="text-white/75 text-sm leading-relaxed mb-8">{author.bio}</p>

        {authoredPosts.length > 0 && (
          <>
            <h2 className="text-2xl font-bold text-white mb-3">Published guides</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="author-profile-post-grid">
              {authoredPosts.map((post) => (
                <Link key={post.slug} to={`/learn/${post.slug}`} className="rounded-xl border border-white/10 bg-navy-800/70 p-4 text-white/80 hover:border-purple-400/45" data-testid={`author-profile-post-link-${post.slug}`}>
                  {post.title}
                </Link>
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
